import type { LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

type HuntSectionSeparatorProps = {
  icon: LucideIcon;
  /** Shown in uppercase via Tailwind */
  label: string;
  /** `muted` matches the original “Find these items” label treatment. */
  labelTone?: "primary" | "muted";
  className?: string;
};

/**
 * Pill label between gradient lines — shared by “Find these items” and “While you wait”.
 */
export function HuntSectionSeparator({
  icon: Icon,
  label,
  labelTone = "primary",
  className,
}: HuntSectionSeparatorProps) {
  return (
    <div className={cn("flex items-center gap-3", className)} role="presentation">
      <div className="h-px min-w-8 flex-1 bg-linear-to-r from-transparent via-muted-foreground/35 to-muted-foreground/20" />
      <div className="flex shrink-0 items-center gap-2 rounded-full border border-border bg-background px-3.5 py-2 shadow-xs backdrop-blur-sm">
        <Icon className="h-4 w-4 shrink-0 text-primary" aria-hidden />
        <span
          className={cn(
            "text-xs font-semibold uppercase tracking-wider",
            labelTone === "muted" ? "text-muted-foreground" : "text-primary"
          )}
        >
          {label}
        </span>
      </div>
      <div className="h-px min-w-8 flex-1 bg-linear-to-l from-transparent via-muted-foreground/35 to-muted-foreground/20" />
    </div>
  );
}
